export default __webpack_public_path__ + "static/media/PayPal-Logo.93ed55d4.png";